module.exports = __webpack_public_path__ + "web/img/articles1.22cb72fe.png";